import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody } from 'reactstrap';
import Routing from '../../utils/Routing';
import ReactPlayer from 'react-player';
import VideoModal from '../video-modal/VideoModal';
import { LargeBusiness } from "../../Constants"
import { css } from 'emotion'
class EirButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      videoPopup: false,
      iconName: this.props.icon
    }
    this.text = '';
  }

  toggleModel = () => {
    this.setState({
      videoPopup: false,
    })
    localStorage.setItem('videoActive', false);
  }

  // toggling icon's class name on hover.
  // NOTE : If this functionality required in all over the site. Then we can remove LargeBusiness.isSite condition
  toggleIconName = (enter) => {
    this.setState({
      iconName: LargeBusiness.isLBSite ? `${this.props.icon}${enter ? "--hover" : ""}` : this.props.icon,
    })
  }

  render() {

    let defaultStyling = {
      backgroundColor: "",
      color: "",
      borderColor: "",
      hover: {
        backgroundColor: "",
        color: "",
        borderColor: "",
      }
    }

    const { text, title, link, ariaLabel, role, className, target, name, value, type, icon, onClick, active, videoModal, buttonStyle = "none", buttonSize = "none", styling = defaultStyling, theme = "light" } = this.props;

    const classLists =
      LargeBusiness.isLBSite ?
        //for lb site
        {
          root: `lb-cta-container d-flex ${buttonStyle == "color-shadow" ? "no-overflow" : ""} ${this.props.justifyContent != undefined ? this.props.justifyContent : ""}`,
          btnContainer: `eir-square-button cta-theme-${theme}`,
          buttonStyle: buttonStyle !== undefined && buttonStyle !== "" ? `btn-${buttonStyle == 'gradient-transparent' ? "gradient-border " + buttonStyle : buttonStyle}` : `btn-default-style`,
          buttonSize: buttonSize !== "none" && buttonSize !== undefined && buttonSize !== "" ? `btn-size-${buttonSize}` : ""
        } :
        //other than lb site
        {
          root: "",
          btnContainer: "",
          buttonStyle: "",
          buttonSize: ""
        };

    // button Style
    let editorCtaBtnStyle = styling != undefined ? {
      backgroundColor: styling.backgroundColor + " !important",
      color: styling.color + " !important",
      borderColor: styling.borderColor + " !important",
      '&:hover': {
        borderColor: styling.hover.borderColor + " !important",
        color: styling.hover.color + " !important",
        backgroundColor: styling.hover.backgroundColor + " !important",
      },
      '&:active': {
        backgroundColor: styling.backgroundColor + " !important",
        color: styling.color + " !important",
        borderColor: styling.borderColor + " !important",
      },
      '&:focus': {
        borderColor: styling.hover.borderColor + " !important",
        color: styling.hover.color + " !important",
        backgroundColor: styling.hover.backgroundColor + " !important",
      },
    } : {}
    // Link Style
    let editorCtaLinkStyle = styling != undefined ? {
      color: styling.color + " !important",
      '&:hover': {
        color: styling.hover.color + " !important",
      },
      '&:focus': {
        color: styling.hover.color + " !important"
      },
      '&:active': {
        color: styling.color
      }
    } : {}
    let colorStyling = styling != undefined ? css`${type == "link" ? { ...editorCtaLinkStyle } : { ...editorCtaBtnStyle }}` : ""

    const buttonElement = () => (<div
      className={`eir-button-cta d-inline ${classLists.btnContainer} ${classLists.buttonStyle} ${classLists.buttonSize}`}
      onMouseEnter={() => this.toggleIconName(true)}
      onMouseLeave={() => this.toggleIconName(false)}
    >
      <Button
        active={active}
        outline={this.getOutline()}
        color={this.getColor()}
        className={`${className ? className : ''} ${colorStyling}`}
        href={videoModal ? () => { this.getModal() } : (link && name && value ? (Routing.addQueryParameter(name, value, link)) : link)}
        target={target}
        title={title}
        onClick={videoModal ? () => { this.getModal() } : onClick}
        name={name}
        aria-label={ariaLabel || undefined}
        value={value}
        type={link ? '' : (name && value ? 'submit' : 'button')}
        data-context={this.props.datacontext}
        data-bundle-code={this.props.databundlecode}
        data-bundle-name={this.props.databundleTitle}
        id={this.props.databundlecode}
        disabled={this.props.disabled}
        role={role}
      >
        {text}
        {type === 'link' && icon ? <span title={title} className={'ml-2 bg-primary eir-icon--circle eir-icon icon-' + this.state.iconName} /> : ''}
        {type === 'button' && icon ? <span title={title} className={'ml-2 eir-icon icon-' + this.state.iconName} /> : ''}
      </Button>

      <VideoModal videoUrl={link} videoPopup={this.state.videoPopup} toggleVideoPopup={this.toggleModel}></VideoModal>

    </div>)
    return (
      LargeBusiness.isLBSite ?
        <div className={classLists.root}>
          {buttonElement()}
        </div>
        : buttonElement()
    );
  }

  getColor = () => {
    switch (this.props.type) {
      case 'button':
        if(this.props.useInlineCSS)return null;
        else{
        return this.props.color ? this.props.color : 'primary';}
      case 'link':
        return 'link';
      default:
        return 'link';
    }
  }
 
    
  getOutline = () => {
    if (this.props.type == 'button') {
      return this.props.outline;
    } else {
      return false;
    }
  }
  getModal = () => {
    this.setState({
      videoPopup: true,
    })
    localStorage.setItem('videoActive', true);
  }
}

EirButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

export default EirButton;
